import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { TreasuryPaymentsProvider } from '../../__generated/treasury/types';
import type { ProductI } from './payment.types';
import { Checkout } from './checkout/checkout.component';
import { Error } from './error/error.component';
import { PaymentError } from './payment-error.types';
import { ThankYou } from './thank-you/thank-you.component';

interface Props {
  product: ProductI;
  paymentMethod: TreasuryPaymentsProvider;
  checkout?: { state: 'success' } | { state: 'error'; errorCode: PaymentError };
}

export const PaymentV2: React.FC<Props> = observer((props) => {
  const { product, checkout } = props;

  if (checkout?.state === 'success') {
    return <ThankYou product={product} />;
  }

  if (checkout?.state === 'error') {
    return <Error productId={product.id} priceId={product.price.id} errorCode={checkout?.errorCode} />;
  }

  return <Checkout product={product} />;
});
